import { Grid } from '@mui/material';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BreachSearch } from './BreachSearch/BreachSearch';
import { Confirmation } from './Confirmation/Confirmation';
import { Failed } from './Failed/Failed';
import { NoMatch } from './NoMatch/NoMatch';

function App() {
  return (
    <Grid container>
      <Grid item xs={2} />
      <Grid item xs={8}>
        <Switch>
          <Route exact path="/">
            <BreachSearch />
          </Route>
          <Route exact path="/confirmation/:ticketNbr/:vrm">
            <Confirmation />
          </Route>
          <Route exact path="/failed">
            <Failed />
          </Route>
          <Route path="*">
            <NoMatch />
          </Route>
        </Switch>
      </Grid>
      <Grid item xs={2} />
    </Grid>
  );
}

export default App;
